/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type reconciliation_CreateRuleRequest = {
    active?: boolean;
    debtorAccountId: string;
    matchValue: string;
    ruleType: reconciliation_CreateRuleRequest.ruleType;
};
export namespace reconciliation_CreateRuleRequest {
    export enum ruleType {
        IBAN = 'iban',
        COUNTERPARTY_NAME = 'counterparty_name',
        FREE_TEXT_REGEX = 'free_text_regex',
        CHILD_ID = 'child_id',
        CHILD_NAME = 'child_name',
        QR_REFERENCE = 'qr_reference',
    }
}

